module.exports = __webpack_public_path__ + "img/kabuki-l.839c5a6b.jpg";